// TODO Server should identify the style to use as a title. Hardcoded here for now.
/**
 * Find the style in the styles category which to use as the title for that category.
 * @param {string} categoryName Category name as part of `styleName`.
 * @param {string} categoryStyles Map of styles by their names in the category.
 * @returns {object|undefined} Text style of the title to use, if any was found.
 */
const findLabelStyle = (categoryName, categoryStyles) => {
  // Find the text styles with defined font size.
  const styles = Object.values(categoryStyles).filter(
    style => style.type === 'text' && style.fontSize != null,
  );
  // End if no style was found.
  if (styles.length === 0) {
    return undefined;
  }
  // Select the text style with largest font size.
  return styles.reduce((acc, style) => (style.fontSize > acc.fontSize ? style : acc));
};

export default findLabelStyle;
